import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchCartItems } from '../../actions'
import GuestCheckoutBlockedModal from '../Checkout/GuestCheckoutBlockedModal'
import ContentLoader from '../global/loaders/ContentLoader'
import Cart from './Cart'

const CartRedirectHandler = props => {
  const [isLoading, setIsLoading] = useState(true)
  const [showEmptyCart, setShowEmptyCart] = useState(false)

  const dispatch = useDispatch()
  const history = useHistory()
  const portal = useSelector(state => state.portal)
  const currentUser = useSelector(state => state.currentUser)

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const result = await dispatch(fetchCartItems())

        if (result?.cart_items?.length > 0 && result?.short_code) {
          history.replace(`/cart/${result.short_code}`)
        } else {
          setShowEmptyCart(true)
          setIsLoading(false)
        }
      } catch {
        setShowEmptyCart(true)
        setIsLoading(false)
      }
    }
    handleRedirect()
  }, [dispatch, history])

  if (!currentUser?.id && portal.checkout_mode === 'registered_only') {
    return <GuestCheckoutBlockedModal />
  }

  if (isLoading) {
    return <ContentLoader />
  }

  if (showEmptyCart) {
    return <Cart {...props} isEmpty />
  }

  return null
}

export default CartRedirectHandler
